import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, View, StyleSheet } from 'react-native';

const DEFAULT_PHOTO = require('../../assets/images/icon.png');

const styles = StyleSheet.create({
  pantryImageContainer: {
    width: 64,
    height: 64,
  },
  pantryImage: {
    width: 64,
    height: 64,
  },
});

class PantryPhoto extends Component {
  static propTypes = {
    url: PropTypes.string,
  };

  render() {
    const { url } = this.props;
    let source = DEFAULT_PHOTO;
    if (url) {
      const resolved =
        url.substring(0, 4) === 'http' ? url : `https://s3.amazonaws.com/nyc-fac-dev/images/${url}`;
      source = { uri: resolved };
    }
    return (
      <View style={styles.pantryImageContainer}>
        <Image source={source} style={styles.pantryImage} />
      </View>
    );
  }
}

export default PantryPhoto;
